export { default } from "./WithStyles";
export { default as WithStylesVoidElement } from "./WithStylesVoidElement";
import { IWithStylesProps } from "./WithStyles";
export type IWithStylesProps = IWithStylesProps;
